(ns practitest.frontend.project-fields-settings.events
  (:require
    [ajax.core :as ajax]
    [re-frame.core :as re-frame]
    [clojure.string :as str]
    [clojure.set :as set]
    [practitest.frontend.common.i18n :refer [get-translation format-translation]]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.global-fields-settings.common :refer [entities]]
    [practitest.frontend.global-fields-settings.entity-linker :refer [default-value-unsupported-formats]]
    [practitest.frontend.forms3.custom-field-form-common :as cf-form-common]
    [practitest.frontend.routing.backend-routes :as broutes]))

(def form-id :project-fields-form)
(def entity-link-table-id :cf-entity)

(re-frame/reg-fx
 :navigate!
 (fn [{:keys [url message]}]
   (when message (js/sessionStorage.setItem "pt-pf-flash" message))
   (set! (.-href js/window.location) url)))

(defn- default-vals-key [field-format]
  (cond
    (#{"list" "multilist"} field-format) :default_vals_list
    (= "user" field-format) :default_vals_users
    :else :default_vals))

;; Builds {entities_to_update [...] mandatories [...] is_defaults [...] default-by-model {...}}
;; from the entity-linker table's {entity-id {:linked :mandatory :has-default? :default}} shape.
(defn- prepare-entity-data [form-fields field-format]
  (let [entities-table-data (get-in form-fields [entity-link-table-id :value])
        supports-default? (not (contains? default-value-unsupported-formats field-format))]
    (reduce (fn [acc [entity-key {:keys [linked mandatory default has-default?]}]]
              (if-not linked
                acc
                (let [model (entity-key entities)]
                  (cond-> acc
                    true
                    (update :entities_to_update conj model)

                    mandatory
                    (update :mandatories conj model)

                    (and supports-default? has-default? (seq default))
                    (-> (update :is_defaults conj model)
                        (assoc-in [:default-by-model model] default))))))
            {:entities_to_update [] :mandatories [] :is_defaults [] :default-by-model {}}
            entities-table-data)))

(defn- restore-entity-data [entity-data]
  (let [entity-keys (set/map-invert entities)
        linked-entities (:entities_to_update entity-data)
        mandatory-set (set (:mandatories entity-data))
        default-by-model (or (:default_by_model entity-data) {})]
    (reduce
      (fn [acc entity]
        (let [key (get entity-keys entity)
              default-value (get default-by-model (keyword entity))]
          (assoc acc key
                 {:linked true
                  :mandatory (contains? mandatory-set entity)
                  :has-default? (some? default-value)
                  :default default-value})))
      {}
      linked-entities)))

(re-frame/reg-event-db
  :project-fields-settings/initialize
  [re-frame/trim-v]
  (fn [db [options]]
    (merge options db)))

(re-frame/reg-event-fx
  :project-fields-settings/init-complete
  (fn [{:keys [db]} _]
    (let [flash (js/sessionStorage.getItem "pt-pf-flash")]
      (js/sessionStorage.removeItem "pt-pf-flash")
      (cond-> {:db (assoc db :project-fields-init-complete? true)}
        flash (assoc :dispatch [::notifications/success2 flash])))))

(re-frame/reg-event-db
 ::init-form-values
 (fn [db [_ custom-field]]
   (let [entities-data (restore-entity-data (:entity_linkage custom-field))
         entity-key-by-model (set/map-invert entities)
         disabled-entity-keys (some->> (seq (:disabled_entities custom-field))
                                       (keep entity-key-by-model)
                                       (into #{}))
         source-cf-name (:possible_values_parent_cf_name custom-field)
         source-cf-obj  (when source-cf-name
                          (first (filter #(= (:name %) source-cf-name) (:source-list-options db))))
         form-values {:cf-name {:dirty? false :errors [] :value (:name custom-field)}
                      :cf-format {:dirty? false :errors [] :value (:field_format custom-field)}
                      :cf-parent-list {:dirty? false :errors [] :value (:parent_list_name custom-field)}
                      :cf-possible-values {:dirty? false :errors [] :value (:possible_values custom-field)}
                      :cf-source-list {:dirty? false :errors [] :value source-cf-obj}
                      :cf-entity {:dirty? false :errors [] :value entities-data}}]
     (-> db
         (update-in [:form-states2 form-id] assoc :fields form-values)
         (update :custom-field assoc :disabled-entity-keys disabled-entity-keys)))))

(re-frame/reg-event-db
 ::reset-form-values
 (fn [db _]
   (update db :form-states2 dissoc form-id)))

(re-frame/reg-event-fx
 ::check-field-relationship
 (fn [{db :db} [_ edit?]]
   (let [{:keys [cf-format cf-parent-list] :as form-fields} (get-in db [:form-states2 form-id :fields])
         project-id (get-in db [:current-route :path-params :project-id])
         custom-field-id (get-in db [:current-route :path-params :custom-field-id])
         uri (broutes/get-url "custom_fields#validate_linkage" {:project_id project-id})
         entity-data (prepare-entity-data form-fields (:value cf-format))
         params {:id custom-field-id
                 :parent_list_id (cf-form-common/find-id-by-name (vals (:project-custom-fields db)) (:value cf-parent-list))
                 :custom_field (merge {:field_format (:value cf-format)} entity-data)}]
     {:db (-> db
             (update :progress conj :check-field-relationship-for-link)
             (assoc-in [:form-states2 form-id :loading?] true))
      :http-xhrio
      {:method :post
       :uri uri
       :params params
       :format (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success [::on-success-check-field-relationship edit?]
       :on-failure [::on-fail-check-field-relationship]}})))

(re-frame/reg-event-fx
  ::on-success-check-field-relationship
  (fn [{:keys [db]} [_ edit? response]]
    (let [has-warnings?     (:has_warnings response)
          validation-result (:validation_result response)
          base-db           (update db :progress disj :check-field-relationship-for-link)]
      (if has-warnings?
        {:db (-> base-db
                 (assoc-in [:form-states2 form-id :loading?] false)
                 (assoc-in [:form-states2 form-id :linkage-modal-data]
                           {:show    true
                            :title   (or (:title validation-result)
                                         (get-translation "global-fields.link.confirmation.title" "Field Linkage Warning"))
                            :message (:message validation-result)}))}
        {:db base-db :dispatch [::save-custom-field {:edit? edit?}]}))))

(re-frame/reg-event-fx
::on-fail-check-field-relationship
 (fn [{db :db} [_ response]]
   {:db (-> db
            (update :progress disj :check-field-relationship-for-link)
            (assoc-in [:form-states2 form-id :loading?] false))
    :dispatch [::notifications/error2 (get-in response [:response :message])]}))

(re-frame/reg-event-fx
 ::save-custom-field
 (fn [{:keys [db]} [_ {:keys [edit?]}]]
   (let [{:keys [cf-format cf-name cf-possible-values cf-parent-list cf-source-list] :as form-fields} (get-in db [:form-states2 form-id :fields])
         project-id (get-in db [:current-route :path-params :project-id])
         custom-field-id (get-in db [:current-route :path-params :custom-field-id])
         event-progress (if edit? ::update-custom-field-progress ::create-custom-field-progress)
         method (if edit? :put :post)
         uri (if edit?
               (broutes/get-url "custom_fields#update" {:project_id project-id :id custom-field-id})
               (broutes/get-url "custom_fields#create" {:project_id project-id}))
         field-format (:value cf-format)
         source-list-obj (:value cf-source-list)
         source-list-id (:id source-list-obj)
         {:keys [entities_to_update mandatories is_defaults default-by-model]} (prepare-entity-data form-fields field-format)
         custom-field {:name (:value cf-name)
                       :field_format field-format
                       :entities_to_update entities_to_update
                       :mandatories mandatories
                       :is_defaults is_defaults
                       :possible_values_parent_cf_id (or source-list-id "")
                       (default-vals-key field-format) default-by-model}
         params {:custom_field_list_values (if source-list-id
                                             ""
                                             (cf-form-common/format-field-values-to-string field-format (:value cf-possible-values)))
                 :parent_list_id (cf-form-common/find-id-by-name (vals (:project-custom-fields db)) (:value cf-parent-list))
                 :validation_type nil
                 :custom_field custom-field}]
     {:db (-> db
              (update :progress conj event-progress)
              (assoc-in [:form-states2 form-id :loading?] true))
      :http-xhrio
      {:method          method
       :uri             uri
       :params          params
       :format          (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success      [::on-successful-save event-progress edit?]
       :on-failure      [::on-save-fail event-progress]}})))

(re-frame/reg-event-fx
 ::on-successful-save
 (fn [{db :db} [_ event-progress edit? response]]
   (let [project-id (get-in db [:current-route :path-params :project-id])
         saved-field (:field response)
         custom-field-id (:id saved-field)
         normalize-entity-table (fn [table]
                                   (update-vals table (fn [v]
                                                        (if (and (:has-default? v) (not (seq (:default v))))
                                                          (assoc v :has-default? false :default nil)
                                                          v))))
         base {:db (-> db
                       (update :progress disj event-progress)
                       (assoc-in [:form-states2 form-id :loading?] false)
                       (cond-> edit?
                         (update-in [:form-states2 form-id :fields]
                                    (fn [fields]
                                      (let [normalized (update-in fields [entity-link-table-id :value] normalize-entity-table)]
                                        (update-vals normalized #(assoc % :dirty? false)))))))}]
     (if edit?
       ;; Stay on the page and show a success notification.
       (assoc base :dispatch [::notifications/success2 (get-translation "custom-fields.notify.updated" "Field was successfully updated")])
       ;; After creation, do a full-page navigation to the Rails edit URL so that
       ;; legacy_init re-runs and seeds :custom-field into the db (SPA navigation
       ;; would leave :custom-field nil and trigger the /permission_error guard).
       ;; The success message is stored in sessionStorage and shown by init-complete.
       (assoc base :navigate! {:url     (str "/projects/" project-id "/custom_fields/" custom-field-id "/edit")
                               :message (get-translation "custom-fields.notify.created" "Field was successfully created")})))))

(re-frame/reg-event-fx
 ::on-save-fail
 (fn [{db :db} [_ event response]]
   (let [{:keys [blocked message usages]} (get-in response [:response])
         base-db (-> db (update :progress disj event)
                        (assoc-in [:form-states2 form-id :loading?] false))]
     (if blocked
       {:db (assoc-in base-db [:form-states2 form-id :modal-data]
                      {:show true :save-blocked? true
                       :title (get-translation "global-fields.error-deleting.title" "Failed to Unlink Field")
                       :message message
                       :usages usages})}
       {:db base-db
        :dispatch [::notifications/error2 message]}))))

(re-frame/reg-event-db
 ::clear-form-loading
 (fn [db _]
   (assoc-in db [:form-states2 form-id :loading?] false)))

;; Convert field

(def ^:private convert-route-by-target
  {"list" "custom_fields#convert_to_list"
   "multilist" "custom_fields#convert_to_multilist"
   "text" "custom_fields#convert_to_text"})

(re-frame/reg-event-db
  ::show-convert-confirmation
  (fn [db [_ id target-format]]
    (assoc-in db [:form-states2 form-id :modal-data]
              {:show true :convert-confirm? true
               :convert-field-id id :convert-target target-format})))

(re-frame/reg-event-fx
  ::convert-field
  (fn [{:keys [db]} [_ id target-format]]
    (let [project-id (get-in db [:current-route :path-params :project-id])
          route-name (get convert-route-by-target target-format)
          convert-url (broutes/get-url route-name {:project_id project-id :id id})]
      {:db (-> db
               (update :progress conj :convert-custom-field-progress)
               (assoc-in [:form-states2 form-id :modal-data] {:show false}))
       :http-xhrio
       {:method :post
        :uri convert-url
        :format (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success [::field-converted]
        :on-failure [::field-convert-error]}})))

(re-frame/reg-event-fx
  ::field-converted
  (fn [{:keys [db]} [_ {:keys [field]}]]
    {:dispatch [::notifications/success2
                (get-translation "global-fields.convert.success" "Field was successfully converted")]
     :db (-> db
             (update :progress disj :convert-custom-field-progress)
             (assoc-in [:form-states2 form-id :fields :cf-format :value] (:type field))
             (assoc-in [:form-states2 form-id :fields :cf-possible-values :value] (:values field)))}))

(re-frame/reg-event-fx
  ::field-convert-error
  (fn [{:keys [db]} [_ {:keys [response]}]]
    (let [{:keys [blocked message usages]} response
          base-db (update db :progress disj :convert-custom-field-progress)]
      (if blocked
        {:db (assoc-in base-db [:form-states2 form-id :modal-data]
                       {:show true :convert-blocked? true
                        :title (get-translation "global-fields.convert.blocked.title"
                                                "Field Cannot Be Converted")
                        :message message
                        :usages usages})}
        {:db base-db
         :dispatch [::notifications/error2 message]}))))

;; Possible value delete/rename

(re-frame/reg-event-fx
 ::check-item-value-usage
 (fn [{db :db} [_ item parent-item]]
   (let [project-id (get-in db [:current-route :path-params :project-id])
         custom-field-id (get-in db [:current-route :path-params :custom-field-id])
         check-url (broutes/get-url "custom_fields#check_value_usage" {:project_id project-id :id custom-field-id})
         params {:value item :parent_list parent-item}]
     {:db (update db :progress conj :check-possible-values-for-deleting)
      :http-xhrio
      {:method :post
       :uri check-url
       :params  params
       :format (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success [::on-success-check-item-value-usage item parent-item]
       :on-failure [::on-fail-check-item-value-usage item parent-item]}})))

(re-frame/reg-event-db
 ::delete-item-from-create-form
 (fn [db [_ value parent-item]]
   (let [possible-values (get-in db [:form-states2 form-id :fields :cf-possible-values :value])
         new-possible-values (if parent-item
                                (update possible-values parent-item
                                        (fn [items] (vec (remove #(= % value) items))))
                                (vec (remove #(= % value) possible-values)))]
     (assoc-in db [:form-states2 form-id :fields :cf-possible-values :value] new-possible-values))))

(re-frame/reg-event-fx
 ::delete-possible-value
 (fn [{db :db} [_ value parent-item]]
   (let [project-id (get-in db [:current-route :path-params :project-id])
         custom-field-id (get-in db [:current-route :path-params :custom-field-id])
         url (broutes/get-url "custom_fields#delete_list_value" {:project_id project-id :id custom-field-id})
         params {:value value :parent_list (some-> parent-item name) :field_type "custom_fields"}]
     {:db (-> db
              (update :progress conj :delete-possible-values)
              (assoc-in [:form-states2 form-id :modal-data] {:show false}))
      :http-xhrio
      {:method :post
       :uri url
       :params  params
       :format (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success [::on-success-delete-possible-value value parent-item]
       :on-failure [::on-fail-delete-possible-value]}})))

(re-frame/reg-event-fx
 ::on-success-delete-possible-value
 (fn [{db :db} [_ value parent-item]]
   (let [possible-values (get-in db [:form-states2 form-id :fields :cf-possible-values :value])
         new-possible-values (if parent-item
                                (update possible-values parent-item
                                        (fn [items] (vec (remove #(= % value) items))))
                                (vec (remove #(= % value) possible-values)))
         clear-entity-default (fn [table]
                                (update-vals table (fn [v]
                                                     (if (= (:default v) value)
                                                       (assoc v :has-default? false :default nil)
                                                       v))))]
     {:db (-> db
              (update :progress disj :delete-possible-values)
              (assoc-in [:form-states2 form-id :fields :cf-possible-values :value] new-possible-values)
              (update-in [:form-states2 form-id :fields entity-link-table-id :value] clear-entity-default))
      :dispatch [::notifications/success2
                 (format-translation
                  (get-translation "global-field.delete-possible-value.success" "Successfully deleted value: %{value}")
                   :value value)]})))

(re-frame/reg-event-fx
 ::on-fail-delete-possible-value
 (fn [{db :db} [_ response]]
   {:db (update db :progress disj :delete-possible-values)
    :dispatch [::notifications/error2 (get-in response [:response :message])]}))

(re-frame/reg-event-db
 ::on-success-check-item-value-usage
 (fn [db [_ item parent-item]]
   (let [modal-data {:show true
                     :delete-value-confirm? true
                     :value item
                     :parent-item parent-item
                     :title (get-translation "global-field.delete-possible-value.modal-title" "Confirm Value Deletion")
                     :value-used? false}]
     (-> db
         (update :progress disj :check-possible-values-for-deleting)
         (assoc-in [:form-states2 form-id :modal-data] modal-data)))))

(re-frame/reg-event-db
 ::on-fail-check-item-value-usage
 (fn [db [_ item parent-item {:keys [response]}]]
   (let [modal-data {:show true
                     :delete-value-confirm? true
                     :title (get-translation "global-field.delete-possible-value.modal-title" "Confirm Value Deletion")
                     :value item
                     :parent-item parent-item
                      ;;for defining text-message in delete-modal-message
                     :value-used? true}]
     (-> db
         (update :progress disj :check-possible-values-for-deleting)
         (assoc-in [:form-states2 form-id :modal-data] modal-data)))))

(defn- rename-in-possible-values [possible-values old-value new-value parent-item]
  (if parent-item
    (update possible-values parent-item (fn [items] (mapv #(if (= % old-value) new-value %) items)))
    (mapv #(if (= % old-value) new-value %) possible-values)))

(re-frame/reg-event-db
 ::open-rename-value-modal
 (fn [db [_ old-value parent-item]]
   (assoc-in db [:form-states2 form-id :rename-modal]
             {:show? true
              :old-value old-value
              :new-value old-value
              :parent-list parent-item
              :error nil})))

(re-frame/reg-event-db
 ::set-rename-new-value
 (fn [db [_ value]]
   (-> db
       (assoc-in [:form-states2 form-id :rename-modal :new-value] value)
       (assoc-in [:form-states2 form-id :rename-modal :error] nil))))

(re-frame/reg-event-db
 ::close-rename-modal
 (fn [db _]
   (update-in db [:form-states2 form-id] dissoc :rename-modal)))

(re-frame/reg-event-fx
 ::submit-rename-value
 (fn [{db :db} _]
   (let [project-id (get-in db [:current-route :path-params :project-id])
         custom-field-id (get-in db [:current-route :path-params :custom-field-id])
         {:keys [old-value new-value parent-list]} (get-in db [:form-states2 form-id :rename-modal])
         linked-list? (some? parent-list)
         route-name (if linked-list? "custom_fields#rename_linked_list_value" "custom_fields#rename_list_cf")
         params (if linked-list?
                  {:parent_list (name parent-list) :current_value old-value :updated_value new-value}
                  {:current_value old-value :updated_value new-value})]
     {:db (-> db
              (update :progress conj ::rename-value-progress)
              (assoc-in [:form-states2 form-id :rename-modal :error] nil))
      :http-xhrio
      {:method :post
       :uri (broutes/get-url route-name {:project_id project-id :id custom-field-id})
       :params params
       :format (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success [::rename-value-success old-value new-value parent-list]
       :on-failure [::rename-value-fail]}})))

(re-frame/reg-event-fx
 ::rename-value-success
 (fn [{db :db} [_ old-value new-value parent-list response]]
   (let [possible-values (get-in db [:form-states2 form-id :fields :cf-possible-values :value])
         new-possible-values (rename-in-possible-values possible-values old-value new-value parent-list)
         message (get response :msg
                       (format-translation
                        (get-translation "global-field.rename-value.success" "Successfully renamed value to %{value}")
                        :value new-value))]
     {:db (-> db
              (update :progress disj ::rename-value-progress)
              (update-in [:form-states2 form-id] dissoc :rename-modal)
              (assoc-in [:form-states2 form-id :fields :cf-possible-values :value] new-possible-values))
      :dispatch [::notifications/success2 message]})))

(re-frame/reg-event-db
 ::rename-value-fail
 (fn [db [_ response]]
   (-> db
       (update :progress disj ::rename-value-progress)
       (assoc-in [:form-states2 form-id :rename-modal :error]
                 (get-in response [:response :message]
                         (get-translation "global-field.rename-value.error" "Failed to rename value"))))))

(re-frame/reg-event-db
  ::clear-dependent-fields
  (fn [db [_ dependent-fields]]
    (reduce
      (fn [db field]
        (assoc-in db [:form-states2 form-id :fields field] {:value nil :dirty? false}))
      db
      dependent-fields)))

;; Source list (Take Values from Existing List)

(re-frame/reg-event-db
 ::show-source-list-confirm
 (fn [db [_ source-obj]]
   (assoc-in db [:form-states2 form-id :source-list-confirm] {:show true :source-obj source-obj})))

(re-frame/reg-event-db
 ::apply-source-list
 (fn [db [_ source-obj]]
   (let [source-values (or (:values source-obj) [])]
     (-> db
         (assoc-in [:form-states2 form-id :fields :cf-source-list] {:value source-obj :dirty? true :errors []})
         (assoc-in [:form-states2 form-id :fields :cf-possible-values] {:value source-values :dirty? true :errors []})
         (update-in [:form-states2 form-id] dissoc :source-list-confirm)))))

(re-frame/reg-event-db
 ::clear-source-list
 (fn [db _]
   (-> db
       (assoc-in [:form-states2 form-id :fields :cf-source-list] {:value nil :dirty? true :errors []})
       (update-in [:form-states2 form-id] dissoc :source-list-confirm))))

(re-frame/reg-event-db
 ::cancel-source-list-confirm
 (fn [db _]
   (update-in db [:form-states2 form-id] dissoc :source-list-confirm)))

(re-frame/reg-event-db
 ::project-fields-hide-modal
 (fn [db [_ modal-key]]
   (assoc-in db [:form-states2 form-id modal-key] {:show false})))

;; ---- System Field Edit ----

(def sf-form-id :system-fields-form)
(def sf-entity-link-table-id :sf-entity)

(defn- prepare-sf-entity-data [form-fields field-format]
  (let [entities-table-data (get-in form-fields [sf-entity-link-table-id :value])
        supports-default? (not (contains? default-value-unsupported-formats field-format))]
    (reduce (fn [acc [entity-key {:keys [linked mandatory default has-default?]}]]
              (if-not linked
                acc
                (let [model (entity-key entities)]
                  (cond-> acc
                    true
                    (update :entities_to_update conj model)

                    mandatory
                    (update :mandatories conj model)

                    (and supports-default? has-default? (seq default))
                    (-> (update :is_defaults conj model)
                        (assoc-in [:default-by-model model] default))))))
            {:entities_to_update [] :mandatories [] :is_defaults [] :default-by-model {}}
            entities-table-data)))

(re-frame/reg-event-db
 ::init-system-field-form-values
 (fn [db [_ system-field]]
   (let [entities-data      (restore-entity-data (:entity_linkage system-field))
         entity-key-by-model (set/map-invert entities)
         allowed-entity-keys (some->> (seq (:possible_entities system-field))
                                      (keep entity-key-by-model)
                                      (into #{}))
         form-values {:sf-display-name {:dirty? false :errors [] :value (:display_name system-field)}
                      :sf-entity       {:dirty? false :errors [] :value entities-data}}]
     (-> db
         (update :system-field assoc :allowed-entity-keys allowed-entity-keys)
         (update-in [:form-states2 sf-form-id] assoc :fields form-values)))))

(re-frame/reg-event-db
 ::reset-system-field-form-values
 (fn [db _]
   (update db :form-states2 dissoc sf-form-id)))

(re-frame/reg-event-fx
 ::save-system-field
 (fn [{:keys [db]} _]
   (let [form-fields (get-in db [:form-states2 sf-form-id :fields])
         system-field (get db :system-field)
         field-format (:field_format system-field)
         system-field-id (get-in db [:current-route :path-params :system-field-id])
         project-id (get-in db [:current-route :path-params :project-id])
         uri (broutes/get-url "system_fields#update" {:p_id project-id :id system-field-id})
         {:keys [entities_to_update mandatories is_defaults default-by-model]} (prepare-sf-entity-data form-fields field-format)
         custom-field {:entities_to_update entities_to_update
                       :mandatories mandatories
                       :is_defaults is_defaults
                       (default-vals-key field-format) default-by-model}
         display-name (get-in form-fields [:sf-display-name :value])]
     {:db (-> db
              (update :progress conj ::save-sf-progress)
              (assoc-in [:form-states2 sf-form-id :loading?] true))
      :http-xhrio
      {:method          :put
       :uri             uri
       :params          {:custom_field custom-field :display_name display-name}
       :format          (ajax/json-request-format)
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success      [::on-successful-sf-save]
       :on-failure      [::on-sf-save-fail]}})))

(re-frame/reg-event-fx
 ::on-successful-sf-save
 (fn [{db :db} _]
   {:db (-> db
            (update :progress disj ::save-sf-progress)
            (assoc-in [:form-states2 sf-form-id :loading?] false)
            (update-in [:form-states2 sf-form-id :fields]
                       (fn [fields]
                         (into {} (map (fn [[k v]] [k (assoc v :dirty? false)]) fields)))))
    :dispatch [::notifications/success2 (get-translation "custom-fields.notify.updated" "Field was successfully updated")]}))

(re-frame/reg-event-fx
 ::on-sf-save-fail
 (fn [{db :db} [_ response]]
   (let [{:keys [blocked message usages]} (get-in response [:response])
         base-db (-> db
                     (update :progress disj ::save-sf-progress)
                     (assoc-in [:form-states2 sf-form-id :loading?] false))]
     (if blocked
       {:db (assoc-in base-db [:form-states2 sf-form-id :modal-data]
                      {:show true :save-blocked? true
                       :title (get-translation "global-fields.error-deleting.title" "Failed to Unlink Field")
                       :message message
                       :usages usages})}
       {:db base-db
        :dispatch [::notifications/error2 message]}))))

(re-frame/reg-event-db
 ::hide-sf-modal
 (fn [db [_ modal-key]]
   (assoc-in db [:form-states2 sf-form-id modal-key] {:show false})))
